import config from "../config";
import store from "../configureStore";
import { fetchData } from "./ajaxActions";

function ajaxError(name, error, type, opts) {
  return {
    error,
    options: opts,
    type: `${type}_${name}_ERROR`,
  };
}

function ajaxSuccess(name, response, type, opts, data) {
  return (dispatch) => {
    dispatch({
      data,
      options: opts,
      response: response,
      type: `${type}_${name}_SUCCESS`,
    });
    if (response.tableupdates) {
      response.tableupdates.forEach((store) => {
        dispatch(fetchData(store));
      });
    }
  };
}

function ajaxRequest(name, options, type) {
  return {
    options,
    type: `${type}_${name}_REQUEST`,
  };
}

export function makeAjaxRequest(name, opts, type, data, callback = null) {
  const token = store.getState().token.token;
  let bodyParams = Object.keys(opts)
    .map((key) => {
      return encodeURIComponent(key) + "=" + encodeURIComponent(opts[key]);
    })
    .join("&");
  bodyParams +=
    "&" + encodeURIComponent("token") + "=" + encodeURIComponent(token);
  return (dispatch) => {
    dispatch(ajaxRequest(name, opts, type));
    let fetchURL = config.url + "/api.php";

    return fetch(fetchURL, {
      method: "post",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: bodyParams,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          response
            .json()
            .then((json) => {
              if (json.success) {
                dispatch(ajaxSuccess(name, json, type, opts, data));
                if (callback) callback();
              } else {
                const error = new Error(json.errors[0].error);
                dispatch(ajaxError(name, error, type, opts));
              }
            })
            .catch((error) => {
              console.log("JSON error in response", error);
            });
        } else {
          const error = new Error(response.statusText);
          error.response = response;
          dispatch(ajaxError(name, error, type, opts));
          throw error;
        }
      })
      .catch((error) => {
        console.log("Request failed", error);
      });
  };
}
